import React from 'react';

import { Color } from 'projects/consts';

interface BriefContext {
    brief: {
        id: string;
        designers: { id: number }[];
        designersWithSource: { source: string }[];
    };
    themeColor?: Color;
    themeName?: string;
}

const Context = React.createContext<BriefContext>({
    brief: { id: '12341234', designers: [], designersWithSource: [] },
});

export default Context;
